// extracted by mini-css-extract-plugin
export default {"header":"JDm_q","inner":"abeTz","loading":"ZmxQk","section":"xzPBP","infoCard":"EXHev","card":"Fxkmi","emptyCoursesState":"qlfzj","emptyState":"VS1n7"};